import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function ViewManagers() {
  const [managerData, setManagerData] = useState([]);
  // const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}managers`, {credentials: "include"})
      .then((response) => response.json())
      .then((data) => {
        if (data.success === true) {
          setManagerData(data.data);
        }
        // setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        // setLoading(false);
      });
  },[]);

  const updateStatus = (status, id) => {
    if (window.confirm("Do you want to change status?")) {
      fetch(`${process.env.REACT_APP_API_URL}managers/${id}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ status }),
      })
        .then((res) => res.json())
        .then((data) => {
          alert(data.message);
          setManagerData((prevData) =>
            prevData.map((manager) =>
              manager._id === id ? { ...manager, status } : manager,
            ),
          );
        })
        .catch((err) => console.error(err));
    }
  };

  // const handleDeletion = (id) => {
  //   if (window.confirm("Delete this profile?")) {
  //     fetch(`${process.env.REACT_APP_API_URL}managers/${id}`, {
  //       method: "DELETE",
  //       credentials: "include",
  //     })
  //       .then((res) => res.json())
  //       .then((data) => {
  //         if(data.success){
  //           setManagerData(prevItems => prevItems.filter(item => item._id !== id));
  //         }
  //         alert(data.message);
  //       });
  //   }
  // };

  return (
    <div className="container mt-5">
      <div className="d-flex flex-row-reverse">
        <Link
          to={`${process.env.PUBLIC_URL}/addManager`}
          className="btn btn-primary mb-3"
        >
          Add Manager
        </Link>
      </div>

      <div className="card shadow p-4">
        <h2 className="mb-4 text-center">Managers</h2>

        {managerData.length > 0 ? (
          <table className="table table-stripped table-bordered">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Edit</th>
                <th>Status</th>
                {/* <th>Delete</th> */}
              </tr>
            </thead>
            <tbody>
              {managerData.length > 0 &&
                managerData.map((data, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{data.name}</td>
                    <td>{data.phone_number}</td>
                    <td>
                      <Link
                        to={`${process.env.PUBLIC_URL}/editManager/${data._id}`}
                        className="btn btn-primary"
                      >
                        <i className="fa fa-pencil" aria-hidden="true"></i>
                      </Link>
                    </td>
                    <td>
                      {data.status === "active" ? (
                        <button
                          className="btn btn-success"
                          onClick={() => updateStatus("inactive", data._id)}
                        >
                          <i className="fa fa-power-off" aria-hidden="true"></i>
                        </button>
                      ) : (
                        <button
                          className="btn btn-danger"
                          onClick={() => updateStatus("active", data._id)}
                        >
                          <i className="fa fa-power-off" aria-hidden="true"></i>
                        </button>
                      )}
                    </td>
                    {/* <td>
                      <button
                        className="btn btn-danger"
                        onClick={() => handleDeletion(data._id)}
                      >
                        <i className="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </td> */}
                  </tr>
                ))}
            </tbody>
          </table>
        ) : (
          <p className="text-center border p-2">No data found</p>
        )}
      </div>
    </div>
  );
}
